/* The rail's arrows, and the loop.

   It wraps rather than cloning the tiles. A seamless loop needs two extra
   copies of every tile in the DOM so there is always something either side of
   the edge, and every tile here is an autoplaying video: six clips become
   eighteen decoding at once, which is a real cost on a phone for an effect
   nobody can see. Wrapping at each end gives the same endless swipe for the
   price of one line. */
(function () {
  function init(root) {
    if (root.dataset.fcSocialInit === '1') return;
    root.dataset.fcSocialInit = '1';

    var rail = root.querySelector('[data-fc-social-rail]');
    var prev = root.querySelector('[data-fc-social-prev]');
    var next = root.querySelector('[data-fc-social-next]');
    if (!rail) return;

    function step() {
      var tile = rail.querySelector('.fc-social__tile');
      if (!tile) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).gap) || 0;
      return tile.getBoundingClientRect().width + gap;
    }

    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }

    /* Hand rolled easing rather than scroll-behavior. A cancellable timer, so
       pressing twice quickly retargets instead of fighting itself. */
    var anim = null;
    function glide(to) {
      if (anim) cancelAnimationFrame(anim);
      var from = rail.scrollLeft;
      var travel = to - from;
      if (!travel) return;
      var started = null;
      var ms = 420;

      function frame(now) {
        if (started === null) started = now;
        var t = Math.min(1, (now - started) / ms);
        var eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        rail.scrollLeft = from + travel * eased;
        if (t < 1) anim = requestAnimationFrame(frame);
        else anim = null;
      }
      anim = requestAnimationFrame(frame);
    }
    function loops() { return maxScroll() > 1; }

    function go(dir) {
      var max = maxScroll();
      var to = rail.scrollLeft + dir * step();

      /* Round tripping. One press past the last tile returns to the first, and
         one press back from the first lands on the last, so the row never
         dead ends. The 2px allows for sub pixel scroll positions. */
      if (dir > 0 && rail.scrollLeft >= max - 2) to = 0;
      else if (dir < 0 && rail.scrollLeft <= 2) to = max;

      glide(Math.max(0, Math.min(to, max)));
    }

    /* The arrows never switch off while the row loops, because there is always
       somewhere to go. They only go quiet when everything already fits. */
    function sync() {
      var on = loops();
      if (prev) prev.disabled = !on;
      if (next) next.disabled = !on;
      root.classList.toggle('fc-social--static', !on);
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    window.addEventListener('resize', sync);

    /* The tiles are sized from an aspect ratio against a width the browser has
       not worked out yet when this runs, so at init the rail measures as having
       nothing to scroll and the arrows latch themselves off. Watch the rail
       instead of asking it once. */
    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(rail);
    } else {
      window.addEventListener('load', sync);
      setTimeout(sync, 500);
    }

    sync();
  }

  function boot() { document.querySelectorAll('.fc-social').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
